module.exports = __webpack_public_path__ + "img/parent.9ed79c1b.svg";